import React from 'react';
import { whyPartners } from '../../mock/content';
import { Rocket, ShieldCheck, Target, Users2 } from 'lucide-react';
import Reveal from './Reveal';

const icons = [Rocket, ShieldCheck, Target, Users2];

const WhyPartners = () => {
  return (
    <section id="why-partners" className="bg-white py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            Why partners choose us
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Built for publishers, not for their advertisers
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            Everyone in demand generation serves the end client. Nobody builds for the B2B publisher holding the relationship. We do – it is the whole business.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
          {whyPartners.map((f, i) => {
            const Icon = icons[i];
            return (
              <Reveal
                key={f.title}
                delay={i * 100}
                className="bg-white rounded-2xl shadow-mk p-7 flex gap-5 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="shrink-0 inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-to-br from-brand-blue to-brand-blue-light text-white shadow-mk-blue">
                  <Icon size={22} strokeWidth={2.2} />
                </div>
                <div>
                  <h3 className="text-navy text-[19px] font-bold">{f.title}</h3>
                  <p className="mt-2 text-body-muted text-[14.5px] leading-[1.7]">{f.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyPartners;
